module.exports = __webpack_public_path__ + "img/PowerPoint.c322a4d6.png";